import { render, staticRenderFns } from "./StationCommands.vue?vue&type=template&id=22420535&scoped=true&lang=pug&"
import script from "./StationCommands.vue?vue&type=script&lang=js&"
export * from "./StationCommands.vue?vue&type=script&lang=js&"
import style0 from "./StationCommands.vue?vue&type=style&index=0&id=22420535&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22420535",
  null
  
)

export default component.exports